import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { ForgotPasswordParams } from '@viome/viome-base/src/usecase/ForgotPassword/ForgotPassword.model';
import { useForgotPasswordMutation } from '@viome/viome-base/src/usecase/ForgotPassword/ForgotPasswordQuery';
import { EMAIL_CONFIRMATION_PATH } from '@/constants/paths';

const defaultSchema = z.object({
  email: z.string().email(),
});

const usePasswordRecovery = () => {
  const [showErrorMessage, setShowErrorMessage] = useState<boolean>(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { mutate, isPending } = useForgotPasswordMutation();

  // Get email from navigation state if available
  const prefilledEmail = location.state?.email || '';

  const form = useForm<ForgotPasswordParams>({
    mode: 'onSubmit',
    resolver: zodResolver(defaultSchema),
    defaultValues: {
      email: prefilledEmail,
    },
  });

  const onValid = (data: ForgotPasswordParams) => {
    setShowErrorMessage(false);
    mutate(data, {
      onError: (error: Error) => {
        console.error('Login failed:', error.message);
        setShowErrorMessage(true);
      },
      onSuccess: () => {
        navigate(EMAIL_CONFIRMATION_PATH);
      },
    });
  };

  return { onValid, form, isLoading: isPending, showErrorMessage };
};

export default usePasswordRecovery;
